module.exports = __webpack_public_path__ + "img/max-file-deny--excel.a2d0059e.svg";